import React__default from 'react';
import { EditUserProfileProvider } from './EditUserProfile/context.js';
import { EditUserProfileUI } from './EditUserProfile/components/EditUserProfileUI.js';
import './chunks/bundle-C7jYHvwG.js';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './chunks/bundle-CIN9yQRB.js';
import './chunks/bundle-pOZPN8hk.js';
import './chunks/bundle-Bk5X1tDl.js';
import './chunks/bundle-MyLy9AIu.js';
import './chunks/bundle-DYeeW5nS.js';
import '@sendbird/chat/groupChannel';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-CDjVXDOc.js';
import './chunks/bundle-Dl9NVsui.js';
import './chunks/bundle-DkviGBGz.js';
import './chunks/bundle-DUTyBaXr.js';
import 'react-dom';
import './chunks/bundle-DfDrbjM5.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-DImSV9VW.js';
import './ui/Icon.js';
import '@sendbird/uikit-tools';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import './chunks/bundle-4W3uBGU3.js';
import '@sendbird/chat/openChannel';
import './chunks/bundle-CLonR-iH.js';
import './chunks/bundle-C6-Ix-Lk.js';
import './ui/SortByRow.js';
import './ui/Input.js';
import './chunks/bundle-CbEyAimK.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-BR3O1lZq.js';
import './ui/TextButton.js';
import './chunks/bundle-Ci2fMtNJ.js';

var EditUserProfile = function (props) {
    var onEditProfile = props.onEditProfile, onCancel = props.onCancel, onThemeChange = props.onThemeChange;
    return (React__default.createElement(EditUserProfileProvider, { onEditProfile: onEditProfile, onCancel: onCancel, onThemeChange: onThemeChange },
        React__default.createElement(EditUserProfileUI, null)));
};

export { EditUserProfile as default };
//# sourceMappingURL=EditUserProfile.js.map
